__turbopack_context__.v({
  "buttonWrapperLeft": "dQdD1W_buttonWrapperLeft",
  "buttonWrapperRight": "dQdD1W_buttonWrapperRight",
  "menuButton": "dQdD1W_menuButton" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "menuButtonActive": "dQdD1W_menuButtonActive",
  "menuContainer": "dQdD1W_menuContainer",
  "navButton": "dQdD1W_navButton",
  "slider": "dQdD1W_slider",
  "tapBar": "dQdD1W_tapBar",
});
